import { useFormContext, useWatch } from 'react-hook-form'
import { CpfCnpjInput } from '../../../../components/CpfCnpjInput'

export function ConsultaCPFCnpj({ isDisabled }) {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const personType = useWatch({ name: 'personType' })

  const mask = personType?.value === 'Pessoa Jurídica' ? '99.999.999/9999-99' : '999.999.999-99'

  return (
    <CpfCnpjInput
      disabled={isDisabled}
      width="100%"
      label="CNPJ/CPF"
      error={errors.cnpjCpf}
      control={control}
      name="cnpjCpf"
      maskChar=""
      mask={mask}
    />
  )
}
